module.exports = __webpack_public_path__ + "static/Arezki-Fahima-c5f22a3362876dd1bcc37b919925a832.jpg";